import { InView } from 'react-intersection-observer';
import TemplateCard from './TemplateCard';
import TemplateCardSkeleton from './TemplateCardSkeleton';
import { useGetUserTemplatesQuery } from '@/hooks/api/template-gallery/useGetUserTemplatesQuery';
import NoResultImage from '@/assets/icons/no-results.svg';

export interface TemplateGalleryUserTemplate {
  _id: string;
  templateName: string;
  templateImage: string;
  boardId: number;
  itemId?: number;
  envelopeId?: string;
  fileId?: string;
  fileType?: string;
  externalTemplateId?: string;
  templateType?: 'document' | 'proposal';
  updatedAt: string;
}
type Props = {
  envelopeId: string;
  searchText: string;
};
const UserTemplates = ({ envelopeId, searchText }: Props) => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage } =
    useGetUserTemplatesQuery(searchText);

  const allRows = data ? data.pages.flatMap((d) => d.rows) : [];

  const onMarkerInViewChange = (inView: boolean) => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-2 md:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <TemplateCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (allRows.length === 0) {
    return (
      <div className="mt-16 flex flex-col items-center justify-center">
        <img src={NoResultImage} alt="No Results" height={100} width={100} />
        <div className="mt-4 text-center text-base font-bold">
          <p>No Results Found</p>
          <p className="text-[14px] font-normal">
            We couldn't find anything matching your search.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto">
      <div className="grid grid-cols-2 gap-2 py-1 md:grid-cols-3">
        {allRows.map((template: TemplateGalleryUserTemplate, i) => (
          <div key={`${template._id}-${i}`}>
            <TemplateCard template={template} envelopeId={envelopeId} />
          </div>
        ))}
        <InView as="div" onChange={onMarkerInViewChange} />
      </div>
      {isFetchingNextPage && (
        <div className="col-span-full mt-2 flex justify-center">
          <span>Loading more...</span>
        </div>
      )}
    </div>
  );
};

export default UserTemplates;
